import React from 'react';
import { Gift } from 'lucide-react';

const FreeAccessNotice = ({ variant = 'full', className = '' }) => {
  if (variant === 'compact') {
    return (
      <div className={`bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-3 ${className}`}>
        <div className="flex items-start gap-2">
          <Gift size={18} className="text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-green-800 dark:text-green-200">
            <strong>Reminder:</strong> All games are free through March 31, 2026. Premium only removes ads during this period.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 ${className}`}>
      <div className="flex items-start gap-3">
        <Gift size={24} className="text-green-600 dark:text-green-400 flex-shrink-0 mt-1" />
        <div className="space-y-2">
          <h3 className="text-base font-semibold text-green-800 dark:text-green-200">
            Play Everything Free Through March 31, 2026!
          </h3>
          <p className="text-sm text-green-700 dark:text-green-300">
            Every game on Solis is free to play until March 31, 2026—no subscription needed!
          </p>
          <p className="text-sm text-green-700 dark:text-green-300">
            Right now, Premium subscriptions only remove ads from the site. All the games (including premium titles) are yours to play without paying a dime during this period.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FreeAccessNotice;
